export class BaseFilterOutput<T> {
    list: T[] = [];
    currentPage: number = 0;
    currentPageSize: number = 0;
    amountOfPages: number = 0;
    totalAmount: number = 0;
}